var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('span',{staticClass:"error-tip"},[_vm._v("401")]),_c('div',[_c('p',[_vm._v("你的账号在其他设备登录，请重新登录!")]),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.handleLogout}},[_vm._v("退出登录")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }